import { render, staticRenderFns } from "./SPratio.vue?vue&type=template&id=eec6594a&scoped=true"
import script from "./SPratio.vue?vue&type=script&lang=js"
export * from "./SPratio.vue?vue&type=script&lang=js"
import style0 from "./SPratio.vue?vue&type=style&index=0&id=eec6594a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eec6594a",
  null
  
)

export default component.exports